import env from 'core/env'

export type RetailerConfig = {
  code: string
  label: string
  subdomain: string
  apiUrl: string
  importExportApiUrl: string
  gatewayApiUrl: string
}

export const LENTA_CODE = 'lenta'
export const OKEY_CODE = 'okey'
export const DIKSI_CODE = 'diksi'
export const SUPER_LENTA_CODE = 'superLenta'

const defaultApiUrl = env.string('VITE_PROVIANTE_BASE_URL', '') ?? ''
const defaultImportExportApiUrl = env.string('VITE_IMPORT_EXPORT_BASE_URL', '') ?? ''
const defaultGatewayApiUrl = env.string('VITE_GATEWAY_BASE_URL', '') ?? ''

function createRetailerConfig(
  code: string,
  label: string,
  subdomain: string = code,
): RetailerConfig {
  const prefix = code.toUpperCase()
  return {
    code,
    label,
    subdomain,
    apiUrl: env.string(`VITE_${prefix}_PROVIANTE_BASE_URL`, defaultApiUrl) ?? defaultApiUrl,
    importExportApiUrl:
      env.string(`VITE_${prefix}_IMPORT_EXPORT_BASE_URL`, defaultImportExportApiUrl) ??
      defaultImportExportApiUrl,
    gatewayApiUrl: defaultGatewayApiUrl,
  }
}

export const RETAILER_CONFIGS: Record<string, RetailerConfig> = Object.fromEntries(
  [
    [LENTA_CODE, 'Лента'],
    [OKEY_CODE, 'Окей'],
    [DIKSI_CODE, 'Дикси'],
    [SUPER_LENTA_CODE, 'Супер Лента', 'super-lenta'],
  ].map((params) => {
    const config = createRetailerConfig(params[0], params[1], params[2])
    return [config.code, config]
  }),
)

export const DEFAULT_RETAILER_CODE = LENTA_CODE
export const RETAILER_CODE_STORAGE_KEY = 'retailer-code'
